export const CREATE_FINAL_APPOINTMENT = 'CREATE_FINAL_APPOINTMENT'
